// get_translation_keys
export const GET_TRANSLATION_KEY = 'get_translation_keys';
export const GET_TRANSLATION_KEY_SUCCESSFUL =
  'get_translation_keys_successfull';
export const GET_TRANSLATION_KEY_FAILED = 'get_translation_keys_failed';

// create_translation_key
export const CREATE_TRANSLATION_KEY = 'create_translation_key';
export const CREATE_TRANSLATION_KEY_SUCCESSFUL =
  'create_translation_key_successfull';
export const CREATE_TRANSLATION_KEY_FAILED = 'create_translation_key_failed';

// update_translation_key
export const UPDATE_TRANSLATION_KEY = 'update_translation_key';
export const UPDATE_TRANSLATION_KEY_SUCCESSFUL =
  'update_translation_key_successfull';
export const UPDATE_TRANSLATION_KEY_FAILED = 'update_translation_key_failed';

// delete_translation_key
export const DELETE_TRANSLATION_KEY = 'delete_translation_key';
export const DELETE_TRANSLATION_KEY_SUCCESSFUL =
  'delete_translation_key_successfull';
export const DELETE_TRANSLATION_KEY_FAILED = 'delete_translation_key_failed';

// start_auto_translation
export const START_AUTO_TRANSLATION = 'start_auto_translation';
export const START_AUTO_TRANSLATION_SUCCESSFUL =
  'start_auto_translation_successfull';
export const START_AUTO_TRANSLATION_FAILED = 'start_auto_translation_failed';

// update_translation_text
export const UPDATE_TRANSLATION_TEXT = 'update_translation_text';
export const UPDATE_TRANSLATION_TEXT_SUCCESSFUL =
  'update_translation_text_successfull';
export const UPDATE_TRANSLATION_TEXT_FAILED = 'update_translation_text_failed';
// update_translation_key_text_state
export const UPDATE_TRANSLATION_KEY_TEXT_STATE =
  'update_translation_key_text_state';
